import React from 'react';
import {Box, Chip, Tooltip} from '@mui/material';
import {useGetErreurQuery} from '../../../modules/simulations/simulations.api';
import {AIDE_ERREUR, pastilleErreur, pastilleErreurCourte} from './sensibiliteRules';

/** Pilule « Erreur mesurée : ±8 % (3 épisodes, rural) » (R-TOUR-03-9) sous le verdict ; la typologie vient du read model `erreur` (cache partagé avec les étalons). */
function PiluleErreur({erreurMesuree, patrimoineId, sx, courte = false}) {
    const {data: erreur} = useGetErreurQuery(String(patrimoineId), {skip: !patrimoineId || erreurMesuree?.typologie != null});
    if (courte) {
        // Lot 9 : version du bandeau de l'atelier, « ±138 % » ; pas d'erreur mesurée = pas de pilule.
        const c = pastilleErreurCourte(erreurMesuree, erreur?.typologie);
        if (!c) return null;
        return (
            <Tooltip title={c.infobulle} arrow>
                <Chip size="small" data-testid="erreur-mesuree" data-etat={c.etat} label={c.libelle}
                      sx={{flex: 'none', fontWeight: 700, bgcolor: '#E7ECF6', color: '#0F2D69', ...sx}}/>
            </Tooltip>
        );
    }
    const p = pastilleErreur(erreurMesuree, erreur?.typologie);
    return (
        <Box data-testid="erreur-mesuree" data-etat={p.etat} sx={sx}>
            <Tooltip title={AIDE_ERREUR} arrow>
                <Chip size="small" label={p.libelle} sx={{fontWeight: 700, bgcolor: p.etat === 'aucun' ? '#EEF1F4' : '#E7ECF6', color: p.etat === 'aucun' ? '#5A6470' : '#0F2D69'}}/>
            </Tooltip>
        </Box>
    );
}

export default PiluleErreur;
